import { Grid, InputLabel, MenuItem } from '@mui/material';
import '../../sass/styles.scss';
import ErrorIcon from '@mui/icons-material/Error';
import { UseScreen } from '../../hooks/UseScreen.hook';

const InvalidDate = () => {

  const screenWidth = UseScreen();

  return (
    <>
        <Grid item xs={ 12 } sx={{ justifyContent: 'center', textAlign: 'center' }}>
            <Grid container>
                <Grid item xs={12}>
                    <ErrorIcon sx={{ fontSize: '10rem' }} />
                </Grid>
                <Grid item xs={12}>
                    {
                        ( screenWidth > 500 ) ?
                        <h5 style={{ margin: '0' }}>Fecha no disponible (no se aceptan fechas anteriores a hoy)</h5>
                        :
                        <h6 style={{ margin: '0' }}>Fecha no disponible (no se aceptan fechas anteriores a hoy)</h6>
                    }
                </Grid>
            </Grid>
        </Grid>
    </>
  )
}

export default InvalidDate